/**
 * 引数の文字数を全角は2文字・半角は1文字として返す
 * @param str
 * @returns
 */
export const characterCount = (str: string): number => {
  let len = 0

  for (let i = 0; i < str.length; i++) {
    str[i].match(/[ -~]/) ? (len += 1) : (len += 2)
  }

  return len
}

/**
 * Queryパラメータを解析して文字列を返す
 * @param value
 * @returns
 */
export const parseQueryParam = (
  value: string[] | string | undefined
): string | undefined => {
  return Array.isArray(value) ? value[0] : value
}

const hankana2ZenkanaMap = {
  ｶﾞ: 'ガ',
  ｷﾞ: 'ギ',
  ｸﾞ: 'グ',
  ｹﾞ: 'ゲ',
  ｺﾞ: 'ゴ',
  ｻﾞ: 'ザ',
  ｼﾞ: 'ジ',
  ｽﾞ: 'ズ',
  ｾﾞ: 'ゼ',
  ｿﾞ: 'ゾ',
  ﾀﾞ: 'ダ',
  ﾁﾞ: 'ヂ',
  ﾂﾞ: 'ヅ',
  ﾃﾞ: 'デ',
  ﾄﾞ: 'ド',
  ﾊﾞ: 'バ',
  ﾋﾞ: 'ビ',
  ﾌﾞ: 'ブ',
  ﾍﾞ: 'ベ',
  ﾎﾞ: 'ボ',
  ﾊﾟ: 'パ',
  ﾋﾟ: 'ピ',
  ﾌﾟ: 'プ',
  ﾍﾟ: 'ペ',
  ﾎﾟ: 'ポ',
  ｳﾞ: 'ヴ',
  ﾜﾞ: 'ヷ',
  ｦﾞ: 'ヺ',
  ｱ: 'ア',
  ｲ: 'イ',
  ｳ: 'ウ',
  ｴ: 'エ',
  ｵ: 'オ',
  ｶ: 'カ',
  ｷ: 'キ',
  ｸ: 'ク',
  ｹ: 'ケ',
  ｺ: 'コ',
  ｻ: 'サ',
  ｼ: 'シ',
  ｽ: 'ス',
  ｾ: 'セ',
  ｿ: 'ソ',
  ﾀ: 'タ',
  ﾁ: 'チ',
  ﾂ: 'ツ',
  ﾃ: 'テ',
  ﾄ: 'ト',
  ﾅ: 'ナ',
  ﾆ: 'ニ',
  ﾇ: 'ヌ',
  ﾈ: 'ネ',
  ﾉ: 'ノ',
  ﾊ: 'ハ',
  ﾋ: 'ヒ',
  ﾌ: 'フ',
  ﾍ: 'ヘ',
  ﾎ: 'ホ',
  ﾏ: 'マ',
  ﾐ: 'ミ',
  ﾑ: 'ム',
  ﾒ: 'メ',
  ﾓ: 'モ',
  ﾔ: 'ヤ',
  ﾕ: 'ユ',
  ﾖ: 'ヨ',
  ﾗ: 'ラ',
  ﾘ: 'リ',
  ﾙ: 'ル',
  ﾚ: 'レ',
  ﾛ: 'ロ',
  ﾜ: 'ワ',
  ｦ: 'ヲ',
  ﾝ: 'ン',
  ｧ: 'ァ',
  ｨ: 'ィ',
  ｩ: 'ゥ',
  ｪ: 'ェ',
  ｫ: 'ォ',
  ｯ: 'ッ',
  ｬ: 'ャ',
  ｭ: 'ュ',
  ｮ: 'ョ',
  '｡': '。',
  '､': '、',
  ｰ: 'ー',
  '｢': '「',
  '｣': '」',
  '･': '・'
}

const zenkana2HankanaMap = Object.entries(hankana2ZenkanaMap).reduce(
  (prev, curr) => {
    return { ...prev, [curr[1]]: curr[0] }
  },
  {}
)

/**
 * 半角カナ/英字を全角カナ/英字に変換する
 * @param str
 * @returns
 */
export const hankana2Zenkana = (str: string) => {
  const reg = new RegExp(
    '(' + Object.keys(hankana2ZenkanaMap).join('|') + ')',
    'g'
  )
  return str
    .replace(reg, function (match) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return hankana2ZenkanaMap[match] || ''
    })
    .replace(/[\u30FC\u2010-\u2015\u2212\uFF70-]/g, 'ー')
    .replace(/ﾞ/g, '゛')
    .replace(/ﾟ/g, '゜')
    .replace(/ /g, '　')
    .replace(/[A-Za-z0-9]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
}

/**
 * 全角カナを半角カナに変換する
 * @param str
 * @returns
 */
export const zenkana2Hankana = (str: string) => {
  const reg = new RegExp(
    '(' + Object.keys(zenkana2HankanaMap).join('|') + ')',
    'g'
  )
  return (
    str
      .replace(reg, function (match) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return zenkana2HankanaMap[match]
      })
      .replace(/゛/g, 'ﾞ')
      .replace(/゜/g, 'ﾟ')
      // eslint-disable-next-line no-irregular-whitespace
      .replace(/　/g, ' ')
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
      })
  )
}

/**
 * 与えた文字数で文字列を分割
 * @param str
 * @param length
 * @returns
 */
export function splitStringByLength(str: string, length: number) {
  if (!str) return []
  const result = []
  for (let i = 0; i < str.length; i += length) {
    result.push(str.slice(i, i + length))
  }
  return result
}

/**
 * URLが有効かどうかを返す
 * @param string
 * @returns
 */
export function isValidUrl(string: string) {
  const regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
  return regex.test(string)
}

const formatter = new Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY'
})

/**
 * 金額をフォーマットする
 */
export const formatPrice = (price?: number) => {
  if (price === undefined) return undefined
  return formatter.format(price)
}
